import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import Portal from "../Portal/Portal";
import { FadeInZoomRef } from "../Transitions/FadeInZoom";
import { getOtherProperties } from "../common/Utils";
import { PopoverProps } from "./PropsType";

export default function Popover(props: PopoverProps) {
  const {
    children,
    className,
    anchorEl = null,
    dir = "bottom-right",
    prefixCls = "bm-Popover",
    ...other
  } = props;
  const [visible, setVisible] = useState(!!props.visible);
  const styleClass = classNames(prefixCls, className);
  const otherProps = getOtherProperties(other, [
    "anchorEl",
    "dir",
    "onClose",
    "visible",
  ]);

  const setElPositionStyle = (elem: any) => {
    if (elem && elem.style) {
      const position: any = getElPositionStyle(elem);
      elem.style.top = position.top + "px";
      elem.style.left = position.left + "px";
      elem.style.transformOrigin = position.transformOrigin;
    }
  };

  const getElPositionStyle = (elem: any) => {
    if (anchorEl) {
      const rect = anchorEl.getBoundingClientRect();
      const width = anchorEl.offsetWidth,
        height = anchorEl.offsetHeight;
      let elemWidth = elem.offsetWidth;
      const offsetWidth = elemWidth - width;
      let left = 0,
        top = rect.top;
      switch (dir) {
        case "top-left":
          left = rect.left - offsetWidth;
          break;
        case "top-center":
          left = rect.left - offsetWidth / 2;
          elemWidth = elemWidth / 2;
          break;
        case "top-right":
          left = rect.left;
          elemWidth = 0;
          break;
        case "bottom-left":
          top = rect.top + height;
          left = rect.left - offsetWidth;
          break;
        case "bottom-center":
          top = rect.top + height;
          left = rect.left - offsetWidth / 2;
          elemWidth = elemWidth / 2;
          break;
        case "bottom-right":
          left = rect.left;
          top = rect.top + height;
          elemWidth = 0;
          break;
      }
      return { left, top, transformOrigin: elemWidth + "px 0 0" };
    }
  };

  const handleClose = () => {
    if (props.onClose) {
      props.onClose();
    }
  };

  useEffect(() => {
    setVisible(!!props.visible);
  }, [props.visible]);

  return (
    <Portal visible={visible} mountNode={document.body}>
      <div className={styleClass} {...otherProps}>
        <div className={`${prefixCls}-mask`} onClick={handleClose} />
        <FadeInZoomRef
          className={`${prefixCls}-inner`}
          in={visible}
          ref={(node) => {
            console.log(node);
            if (node) {
              setElPositionStyle(node);
            }
          }}
        >
          {children}
        </FadeInZoomRef>
      </div>
    </Portal>
  );
}
